module.exports = __webpack_public_path__ + "icon-status-user.png";